<template>
  <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <h1 class="m-0">
            Fluxo de cadastros
            <a @click="refresh()" type="button" class="btn btn-info" style="margin-left: 15px">
              <i class="fa-solid fa-rotate-right" style="margin-right: 5px"></i>
              Atualizar página
            </a>
          </h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-12">
          <ol class="breadcrumb float-sm-left">
            <li class="breadcrumb-item"><a href="/">Home</a></li>
            <li class="breadcrumb-item active">Fluxo de cadastros</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>

  <div class="card card-primary">
    <div class="card-header">
      <div class="card-title" id="name">
        <ul class="nav nav-pills ml-auto">
          <li class="nav-item">
            <a
              id="confirmando_email"
              class="nav-link"
              :class="aba_atual == 'confirmando_email' ? 'active' : ''"
              href="#revenue-chart"
              data-toggle="tab"
              @click="search('confirmando_email')"
              :style="getStyle('confirmando_email')"
            >
              Falta verificar e-mail
              <span v-if="aba_atual == 'confirmando_email'" class="right badge badge-secondary" style="margin-left: 5px">
                {{ total }}
              </span>
            </a>
          </li>
          <li class="nav-item">
            <a
              id="preenchendo_perfil"
              class="nav-link"
              :class="aba_atual == 'preenchendo_perfil' ? 'active' : ''"
              href="#sales-chart"
              data-toggle="tab"
              @click="search('preenchendo_perfil')"
              :style="getStyle('preenchendo_perfil')"
            >
              Falta preencher cadastro
              <span v-if="aba_atual == 'preenchendo_perfil'" class="right badge badge-secondary" style="margin-left: 5px">
                {{ total }}
              </span>
            </a>
          </li>
          <li class="nav-item">
            <a
              id="confirmando_sms"
              class="nav-link"
              :class="aba_atual == 'confirmando_sms' ? 'active' : ''"
              href="#tab3"
              data-toggle="tab"
              @click="search('confirmando_sms')"
              :style="getStyle('confirmando_sms')"
            >
              Falta validar SMS
              <span v-if="aba_atual == 'confirmando_sms'" class="right badge badge-secondary" style="margin-left: 5px">
                {{ total }}
              </span>
            </a>
          </li>

          <li class="nav-item">
            <a
              id="aguardando_documentos"
              class="nav-link"
              :class="aba_atual == 'aguardando_documentos' ? 'active' : ''"
              href="#tab4"
              data-toggle="tab"
              @click="search('aguardando_documentos')"
              :style="getStyle('aguardando_documentos')"
            >
              Aguardando documentos
              <span v-if="aba_atual == 'aguardando_documentos'" class="right badge badge-secondary" style="margin-left: 5px">
                {{ total }}
              </span>
            </a>
          </li>

          <li class="nav-item">
            <a
              id="aguardando_liberacao"
              class="nav-link"
              :class="aba_atual == 'aguardando_liberacao' ? 'active' : ''"
              href="#tab5"
              data-toggle="tab"
              @click="search('aguardando_liberacao')"
              :style="getStyle('aguardando_liberacao')"
            >
              Aguardando liberação
              <span v-if="aba_atual == 'aguardando_liberacao'" class="right badge badge-secondary" style="margin-left: 5px">
                {{ total }}
              </span>
            </a>
          </li>

          <li class="nav-item">
            <a
              id="pendentes"
              class="nav-link"
              :class="aba_atual == 'pendentes' ? 'active' : ''"
              href="#tab6"
              data-toggle="tab"
              @click="search('pendentes')"
              :style="getStyle('pendentes')"
            >
              Pendentes
              <span v-if="aba_atual == 'pendentes'" class="right badge badge-secondary" style="margin-left: 5px">
                {{ total }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <!-- /.card-header -->

    <div class="tab-content p-0">
      <!-- Morris chart - Sales -->
      <div :class="aba_atual == 'confirmando_email' ? 'active' : ''" class="chart tab-pane" id="revenue-chart" style="position: relative">
        <workflow-unverified-mail :action="alterarValores" v-if="aba_atual == 'confirmando_email'" />
      </div>
      <div :class="aba_atual == 'preenchendo_perfil' ? 'active' : ''" class="chart tab-pane" id="sales-chart" style="position: relative">
        <workflow-non-profile :action="alterarValores" v-if="aba_atual == 'preenchendo_perfil'" />
      </div>
      <div :class="aba_atual == 'confirmando_sms' ? 'active' : ''" class="chart tab-pane" id="tab3" style="position: relative">
        <workflow-unverified-phone :action="alterarValores" v-if="aba_atual == 'confirmando_sms'" />
      </div>
      <div :class="aba_atual == 'aguardando_documentos' ? 'active' : ''" class="chart tab-pane" id="tab4" style="position: relative">
        <workflow :action="alterarValores" v-if="aba_atual == 'aguardando_documentos'" />
      </div>
      <div :class="aba_atual == 'aguardando_liberacao' ? 'active' : ''" class="chart tab-pane" id="tab5" style="position: relative">
        <workflow-aguardando-liberacao :action="alterarValores" v-if="aba_atual == 'aguardando_liberacao'" />
      </div>
    </div>
    <div :class="aba_atual == 'pendentes' ? 'active' : ''" class="chart tab-pane" id="tab6" style="position: relative">
      <workflow-pendentes :action="alterarValores" v-if="aba_atual == 'pendentes'" />
    </div>
  </div>
</template>

<script>
export default {
  props: [""],

  mixins: [],

  components: {},

  data() {
    return {
      isLoading: false,
      doc_tipo_usuario_selecionado: "",
      upload_files: "",
      aux_docs_tipo_usuario: [],
      aba_atual: "",
      nome_aba: "",
      total: 0,
    };
  },

  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    let filter = urlParams.get("filter");

    if (filter) {
      this.$nextTick(function () {
        document.getElementById(filter).click();
      });
    } else {
      this.aba_atual = "confirmando_email";
    }
  },

  methods: {
    refresh() {
      window.location.reload();
    },

    search(aba) {
      console.log("BUSCANDO ABA " + aba);

      console.log("Aba atual " + this.aba_atual);

      if (this.aba_atual == aba) {
        let btn = document.getElementById("searchBtn");
        btn.click();
      }

      this.aba_atual = aba;

      const urlParams = new URLSearchParams(window.location.search);

      window.history.replaceState(null, null, "?filter=" + aba);
    },

    getStyle(aba) {
      if (aba == this.aba_atual) {
        return "color: white !important";
      } else {
        return "color: white !important";
      }
    },

    alterarValores(nome, total) {
      this.nome_aba = nome;
      this.total = total;
    },

    redirect(doc) {
      window.location.href = "/admin/user/document/view/" + doc.id;
    },
  },
};
</script>

<style scoped>
tr {
  cursor: pointer;
}

.nav-link:hover {
  color: white;
}
</style>
